import axiosInstance from "../../Config/axiosConfig";

export const getVirtualGifts = async (page = 1, limit = 12) => {
  try {
    const response = await axiosInstance.get('/user/gifts/virtual', {
      params: { page, limit }
    });
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const getMyVirtualGifts = async (page = 1, limit = 12) => {
  try {
    const response = await axiosInstance.get('/user/gifts/my-virtual', {
      params: { page, limit }
    });
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const getGreetingCards = async (page = 1, limit = 12) => {
  try {
    const response = await axiosInstance.get('/user/gifts/greeting-card', {
      params: { page, limit }
    });
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const getMyGreetingCards = async (page = 1, limit = 12, search = '') => {
  try {
    const response = await axiosInstance.get('/user/gifts/my-greeting-card', {
      params: { page, limit, search: search || undefined }
    });
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const purchaseGift = async (giftId, quantity) => {
  try {
    const response = await axiosInstance.post('/user/gifts/buy', {
      gift_id: giftId,
      quantity: quantity
    });
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const sendGift = async (giftId, quantity, userId) => {
  try {
    const response = await axiosInstance.post('/user/gifts/send', {
      gift_id: giftId,
      quantity: quantity,
      user_id: userId
    });
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

